import request from '@/utils/request'

export const fixWaiting = () =>
  request({
    url: '/admin/pull_requests/fix_waiting',
    method: 'put'
  })